const STORAGE_KEY = 'hlm-on-servis-wizard-snapshot';

export function saveOnServisWizardSnapshot(snapshot) {
  if (!snapshot?.onServisKaydiId) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...snapshot, savedAt: Date.now() }));
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadOnServisWizardSnapshot() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.onServisKaydiId ? parsed : null;
  } catch {
    return null;
  }
}

export function clearOnServisWizardSnapshot() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
